var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAction = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Modern-Weapon-Machine-Gun-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Modern Weapon Machine Gun 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.78 0.79a1 1 0 0 0 -1.41 0l-0.69 0.69a0.23 0.23 0 0 1 -0.17 0.08 0.25 0.25 0 0 1 -0.18 -0.08L19.13 0.29a1 1 0 0 0 -1.42 1.42l1.22 1.21a0.26 0.26 0 0 1 0 0.35l-2.74 2.78a0.5 0.5 0 0 0 0 0.7l0.74 0.75a0.46 0.46 0 0 0 0.64 0l5.22 -5.3a1 1 0 0 0 -0.01 -1.41Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.55 12.43a6.46 6.46 0 0 1 -3.09 -1.34 0.45 0.45 0 0 1 -0.19 -0.36 0.5 0.5 0 0 1 0.14 -0.39l0.81 -0.81a1 1 0 0 0 0 -1.41L14.11 6a1.05 1.05 0 0 0 -0.71 -0.29 1 1 0 0 0 -0.71 0.3l-6.55 6.68a1.51 1.51 0 0 0 -0.43 1.05v1.78a0.26 0.26 0 0 1 -0.07 0.18l-4.43 4.42a1 1 0 0 0 0 1.42l2.18 2.17a1 1 0 0 0 0.85 0.28 1 1 0 0 0 0.76 -0.52l2.79 -5.18a0.55 0.55 0 0 1 0.34 -0.29 0.52 0.52 0 0 1 0.43 0.14l1.8 1.86a0.51 0.51 0 0 0 0.71 0l1.29 -1.3a0.48 0.48 0 0 0 0 -0.7l-1.94 -2a0.51 0.51 0 0 1 0 -0.71l2.15 -2.15a0.49 0.49 0 0 1 0.66 0 6.66 6.66 0 0 0 4 1.49 0.5 0.5 0 0 0 0.37 -0.14l1.21 -1.21a0.5 0.5 0 0 0 0.12 -0.51 0.51 0.51 0 0 0 -0.38 -0.34Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAction);
export default ForwardRef;